<template>
    <div class="asset-manage">
        <!-- <el-button class="management-btn"><i class="manage-icon"></i><i>资产管理</i></el-button> -->
        <lead :headOption="headOption" />
        <main class="asset-main">
            <template v-if="!isShowNav">
                <nav>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane v-for="(item,index) of navData" :key="index" :label="item.label" :name="item.name">
                            <router-view />
                        </el-tab-pane>
                    </el-tabs>
                </nav>
            </template>
            <template v-else>
                <router-view :key="Date.now()"/>
            </template>
        </main>
        <foote />
    </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";

export default {
    components: {
        lead,
        foote
    },
    data() {
        return {
            // 顶部模块标题：
            headOption: {
                link: "/assetManage",
                title: "资产管理"
            },
            // // 导航默认选中项
            // activeName: "0",
            //导航栏数据
            navData: [
                {
                    label: "资产列表",
                    name: "0"
                },
                {
                    label: "资产大数据",
                    name: "1"
                }
            ]
        };
    },
    created() {
        this.activeName = is_empty(sessionStorage.getItem('activeName')) ? "0" : sessionStorage.getItem('activeName');

    },
    mounted() {

    },
    computed: {
        // 是否隐藏导航条
        isShowNav: function () {
            return this.$route.path == "/assetManage/detail" || this.$route.path == "/assetManage/detail/" ? true : false;
        }
    },
    methods: {
        // 导航点击切换页面
        handleClick(tab) {
            tab.name == "0" ? (this.$router.push("/assetManage")) : (this.$router.push("/assetManage/data"));
            this.activeName = tab.name;
            sessionStorage.setItem('activeName', tab.name)
        }
    },
};
</script>
<style lang="scss">
.asset-manage {
    position: relative;
}
.management-btn {
    position: absolute;
    top: 22px;
    right: 40px;
    padding: 0;
    width: 120px;
    height: 36px;
    background-color: #deefff;
    i {
        vertical-align: middle;
    }
    .manage-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 18px;
        background: url("../../../assets/images/assetManage/mange_icon.png");
    }
}
.asset-main {
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    min-height: calc(100vh - 124px);
    padding: 18px 0 40px;
    nav {
        .el-tabs__header {
            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
            border-radius: 3px;
            background-color: #fff;
            margin: 0;
        }
        .el-tabs__nav-wrap {
            padding-left: 40px;
        }
        .el-tabs__active-bar {
            height: 4px;
        }
        .el-tabs__nav-wrap::after {
            background-color: transparent;
        }
        .el-tabs__item {
            height: 60px;
            line-height: 60px;
        }
    }
}

@import "./../../../assets/css/assetManage.scss";
</style>